import Cookie from 'js-cookie';
import React, { useEffect, useState } from 'react';
import bgMp4 from 'src/assets/bg.mp4';
import logo from 'src/assets/logo.png';
import Login from 'src/components/Login';
import useModal from 'src/hooks/useModal';
import http from 'src/util/http';
import style from './style.module.scss';
import './index.css';

export default function Home() {
    const [isLogin, setIsLogin] = useState(false);
    const [user, setUser] = useState('');
    useEffect(() => {
        const token = Cookie.get('auth_token');
        if (token) {
            http.get<{ username: string }>('user_info', { token })
                .then(res => {
                    setUser(res.data.username);
                    setIsLogin(true);
                })
                .catch(() => {
                    Cookie.remove('auth_token');
                });
        }
    }, []);
    const redirect = () => {
        window.open('https://editor.56show.com/project', '_blank');
    };
    const loginModal = useModal(<Login />, { closable: true, maskClosable: false });
    const login = () => {
        if (isLogin) return;
        loginModal.open();
    };

    return (
        <>
            <div className={style.bg}>
                <video className={style.bg_video} src={bgMp4} autoPlay loop muted />
            </div>
            <div className={style.container}>
                <div className={style.logo}>
                    <img src={logo} alt="云剪辑" />
                </div>
                <h1 className={style.title}>无需专业基础,&nbsp;&nbsp;轻松编辑视频</h1>
                <h3 className={style.subtitle}>
                    免费在线视频编辑器，功能全面、操作简单，无需任何经验即可快速上手
                </h3>
                <div className={style.buttons}>
                    <div className={[style.btn, style.login].join(' ')} onClick={login}>
                        <span>{isLogin ? user : '用户登录'}</span>
                        <h3>{isLogin ? '欢迎您' : '立即登录'}</h3>
                    </div>
                    <div className={[style.btn, style.start].join(' ')} onClick={redirect}>
                        <span>进入云剪</span>
                        <h3>开始创作</h3>
                    </div>
                    <div
                        className={[style.btn, style.feedback].join(' ')}
                        onClick={() => window.open('https://qm.qq.com/q/2LyxiFD9zq', '_blank')}
                    >
                        <span>意见反馈</span>
                        <h3>联系我们</h3>
                    </div>
                </div>
            </div>
            <div className={style['copy-right']}>
                <a href="https://beian.miit.gov.cn/" target="_blank">
                    京ICP备09007201号-2
                </a>
            </div>
        </>
    );
}
